export default "__VITE_ASSET__Xs625ikV__"